import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ReferenceLine, ResponsiveContainer
} from 'recharts';
import { Grid, Card, CardContent, Typography } from '@mui/material';

export default function Dashboard() {
  // Initialize state for data, loading, and errors
  const [metrics, setMetrics] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function loadMetrics() {
      try {
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/metrics/weekly_output/`,
          { withCredentials: true }
        );
        setMetrics(response.data);
      } catch (err) {
        console.error(err);
        setError(err.message || 'Failed to load metrics');
      } finally {
        setLoading(false);
      }
    }
    loadMetrics();
  }, []);

  // Handle loading and error states
  if (loading) {
    return <div>Loading data...</div>;
  }
  if (error) {
    return <div style={{ color: 'red' }}>Error: {error}</div>;
  }
  if (!metrics) {
    return <div>No metrics available.</div>;
  }

  // Destructure metrics safely
  const { days = [], weekly_avg = 0, monthly_avg = 0, draw_line = 0, goal_line = 0 } = metrics;

  return (
    <Grid container spacing={2}>

      {/* Tile: Weekly Output Bar Chart */}
      <Grid item xs={12} md={8}>
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              This Week’s Coated Value
            </Typography>
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={days}>
                <XAxis dataKey="day" />
                <YAxis />
                <Tooltip formatter={val => `$${(val ?? 0).toLocaleString()}`} />
                <Legend />
                <Bar dataKey="value" name="Completed" />
                <ReferenceLine y={draw_line} strokeDasharray="3 3" name="Draw Line" />
                <ReferenceLine y={goal_line} name="Goal Line" />
              </BarChart>
            </ResponsiveContainer>
          </CardContent>
        </Card>
      </Grid>

      {/* Tile: Average Outputs */}
      <Grid item xs={12} md={4}>
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Average Daily Output
            </Typography>
            <Typography>
              Weekly Avg: <strong>${(weekly_avg ?? 0).toLocaleString()}</strong>
            </Typography>
            <Typography>
              Monthly Avg: <strong>${(monthly_avg ?? 0).toLocaleString()}</strong>
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      {/* You can add more tiles below… */}
    </Grid>
  );
}
